import { useQuery } from '@tanstack/react-query'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import { FETCH_REGISTRY_KEY, fetchRegistry } from 'src/api/queries'
import { Registry } from 'src/types/registry'

export const useRegistry = () => {
  const [currentUser] = useCurrentUser()

  const registryId = currentUser?.currentRegistry?.id

  const registryQuery = useQuery<Registry>({
    enabled: !!registryId,
    queryKey: [FETCH_REGISTRY_KEY, registryId],
    queryFn: () => fetchRegistry(registryId),
  })

  return registryQuery.data
}
